const infoHeadTitleList = [
  {
    headTitle: "申請手当名",
  },
  {
    headTitle: "対応規程",
  },
  {
    headTitle: "申請状況",
  },
  {
    headTitle: "非該当理由",
  },
  {
    headTitle: "対象施設",
  },
];
export { infoHeadTitleList };
